import {
  GET_PRIORITY_ORDERS_SUCCESS,
  GET_PRIORITY_ORDERS_FAIL,
  ADD_PRIORITY_ORDER_SUCCESS,
  ADD_PRIORITY_ORDER_FAIL,
  UPDATE_PRIORITY_ORDER_SUCCESS,
  UPDATE_PRIORITY_ORDER_FAIL,
  DELETE_PRIORITY_ORDER_SUCCESS,
  DELETE_PRIORITY_ORDER_FAIL,
  GET_SPEC_PRIORITY_ORDERS_SUCCESS,
  GET_SPEC_PRIORITY_ORDERS_FAIL,
  GET_ACRHIVE_PRIORITY_ORDERS_SUCCESS,
  GET_ACRHIVE_PRIORITY_ORDERS_FAIL,
  GET_HISTORY_SUCCESS,
  GET_HISTORY_FAIL,
  SHOW_LOADING,
  HIDE_LOADING,
} from "./actionTypes"

const INIT_STATE = {
  priority_orders: [],
  archive_priority_orders: [],
  history_data: [],
  sl_managers: [],
  wh_managers: [],
  fees: [],
  boxSizes: [],
  tr_agents: [],
  count: 0,
  success: null,
  error: null,
  loading: false,
}

const priority_orders = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRIORITY_ORDERS_SUCCESS:
      return {
        ...state,
        priority_orders: action.payload[0],
        sl_managers: action.payload[1],
        wh_managers: action.payload[2],
        tr_agents: action.payload[3],
        fees: action.payload[4],
        boxSizes: action.payload[5]
      };
    case GET_PRIORITY_ORDERS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    
    case GET_ACRHIVE_PRIORITY_ORDERS_SUCCESS:
      return {
        ...state,
        archive_priority_orders: action.payload[0],
        count: action.payload[1]
      };
    case GET_ACRHIVE_PRIORITY_ORDERS_FAIL:
      return {
        ...state,
        error: action.payload
      };
    
    case GET_SPEC_PRIORITY_ORDERS_SUCCESS:
      return {
        ...state,
        archive_priority_orders: action.payload[0],
        count: action.payload[1]
      };
    case GET_SPEC_PRIORITY_ORDERS_FAIL:
      return {
        ...state,
        error: action.payload
      };
    
    case ADD_PRIORITY_ORDER_SUCCESS:
      return {
        ...state,
        priority_orders: [...state.priority_orders, action.payload],
        success: { data: "success" },
      };
    case ADD_PRIORITY_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    
    case UPDATE_PRIORITY_ORDER_SUCCESS:
      // If action.payload is an array of orders then
      if (Array.isArray(action.payload)) {
        const orders = action.payload.reduce((prv, curr) => {
          prv[curr._id] = curr;
          return prv;
        }, {})
        return {
          ...state,
          priority_orders: state.priority_orders.map(service => {
            const id = service._id.toString()
            return id in orders
              ? { service, ...orders[id] }
              : service
          }),
          success: { data: "success" },
        };
      }
      else return {
        ...state,
        priority_orders: state.priority_orders.map(service =>
          service._id.toString() === action.payload._id.toString()
            ? { service, ...action.payload }
            : service
        ),
        success: { data: "success" },
      };
    case UPDATE_PRIORITY_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    
    case DELETE_PRIORITY_ORDER_SUCCESS:
      return {
        ...state,
        priority_orders: state.priority_orders.filter(
          service => service._id.toString() !== action.payload._id.toString()
        ),
      };
    case DELETE_PRIORITY_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_HISTORY_SUCCESS:
      return {
        ...state,
        history_data: action.payload
      };
    case GET_HISTORY_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case SHOW_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case HIDE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state
  }
}

export default priority_orders